"use strict";
/*
 * Created on 06 17 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultObjectConverter_1 = require("../../core/model/errors/conversions/ValidationResultObjectConverter");

var Permission_1 = require("../../user/model/Permission");

var Role_1 = require("../../user/model/Role");

var DashboardTask_1 = require("../model/DashboardTask");

var DashboardTaskState_1 = require("../model/DashboardTaskState");

var DashboardTaskType_1 = require("../model/DashboardTaskType");

var DashboardTaskConverter_1 = require("./DashboardTaskConverter");
/**
 * @author Jaroslav Sevcik
 */


var DashboardTaskConverterImpl =
/*#__PURE__*/
function (_DashboardTaskConvert) {
  _inherits(DashboardTaskConverterImpl, _DashboardTaskConvert);

  function DashboardTaskConverterImpl(validationResultObjectConverter) {
    var _this;

    _classCallCheck(this, DashboardTaskConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DashboardTaskConverterImpl).call(this));
    _this.validationResultObjectConverter = validationResultObjectConverter;
    return _this;
  }

  _createClass(DashboardTaskConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      return Object.assign(result, {
        message: this.validationResultObjectConverter.toDocument(source.message, conversions),
        roles: conversions.asObjectArray(source, 'roles', function (role) {
          return {
            name: role.name
          };
        }),
        permission: conversions.asObject(source, 'permission', function (permission) {
          return {
            name: permission.name
          };
        }),
        productCategoryId: conversions.toDocumentReferenceId(source.productCategoryId),
        deadline: conversions.fromDate(source.deadline),
        state: source.state,
        type: source.type
      });
    }
  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new DashboardTask_1.DashboardTask(conversions.documentToClassId(source), conversions.asObject(source, 'message', function (message) {
        return _this2.validationResultObjectConverter.toObject(message, conversions);
      }), conversions.asObjectList(source, 'roles', function (roleDoc) {
        return new Role_1.Role(roleDoc.name);
      }), conversions.asObject(source, 'permission', function (permission) {
        return new Permission_1.Permission(permission.name);
      }), conversions.toClassReferenceId(source.productCategoryId), conversions.toDate(source.deadline), conversions.asEnum(source.state, DashboardTaskState_1.DashboardTaskState), conversions.asEnum(source.type, DashboardTaskType_1.DashboardTaskType));
    }
  }]);

  return DashboardTaskConverterImpl;
}(DashboardTaskConverter_1.DashboardTaskConverter);

DashboardTaskConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultObjectConverter_1.ValidationResultObjectConverter])], DashboardTaskConverterImpl);
exports.DashboardTaskConverterImpl = DashboardTaskConverterImpl;